import logo from "../assets/logo.jpg.jpeg";
export const BRAND = {
  name: "VR Marketing Hub",
  logo: logo,
  phone: "+91 8209507277",
  phoneDigits: "918209507277",
  email: "vrmarketinghub111@gmail.com",
  whatsappLink:
    "https://wa.me/918209507277?text=Hi%20VR%20Marketing%20Hub,%0A%0AI%20would%20like%20a%20FREE%20Marketing%20Consultation.%0A%0AName:%20%0ABusiness:%20%0ACity:%20%0AMobile:%20",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "Industries", href: "#industries" },
  { label: "About", href: "#about" },
  { label: "Why Us", href: "#why" },
  { label: "Process", href: "#process" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = [
  { title: "Meta Ads Management", desc: "Full-funnel Meta Ads engineered for ROAS across Facebook & Instagram.", icon: "Target" },
  { title: "Facebook Ads", desc: "Precision audience targeting for scalable lead & sales campaigns.", icon: "Facebook" },
  { title: "Instagram Ads", desc: "Creative-first Instagram campaigns that build brand and revenue.", icon: "Instagram" },
  { title: "AI Content Creation", desc: "AI-assisted content strategy — reels, carousels, captions & blogs.", icon: "Sparkles" },
  { title: "AI Video Editing", desc: "Short-form video edits optimised for reels, shorts and ad hooks.", icon: "Film" },
  { title: "Social Media Management", desc: "End-to-end social handling — planning, creatives, publishing & reports.", icon: "Share2" },
  { title: "Lead Generation", desc: "Predictable, qualified lead pipelines connected to your CRM.", icon: "Magnet" },
  { title: "Landing Page Design", desc: "High-converting landing pages built for Indian buyers.", icon: "LayoutTemplate" },
  { title: "Website Development", desc: "Fast, SEO-ready websites in React & Next.js.", icon: "Code2" },
  { title: "Graphic Design", desc: "Premium creative design — brand kits, ads, posts, brochures.", icon: "Palette" },
  { title: "WhatsApp Marketing", desc: "Broadcasts, automations & catalog flows on WhatsApp Business.", icon: "MessageCircle" },
  { title: "CRM Automation", desc: "Automate lead capture, nurturing, follow-ups and reporting.", icon: "Workflow" },
];

export const INDUSTRIES = [
  "Restaurant", "Salon", "Clinic", "Gym", "Hospital", "Education",
  "Retail Shop", "Jewellery", "Real Estate", "Travel", "Construction",
  "Manufacturing", "Automobile", "Finance", "E-commerce", "Service Businesses",
];

export const WHY_US = [
  { title: "Personalized Marketing Strategy", desc: "Every plan is tailored to your business, goals and geography.", icon: "UserCog" },
  { title: "AI-Powered Marketing", desc: "Modern AI workflows for content, targeting and optimisation.", icon: "Cpu" },
  { title: "Transparent Communication", desc: "Clear reporting, honest metrics and no jargon — ever.", icon: "Eye" },
  { title: "Dedicated Support", desc: "A committed team responding on WhatsApp, email & calls.", icon: "Headphones" },
  { title: "Affordable Growth Solutions", desc: "Pricing designed for Indian SMBs and growing brands.", icon: "IndianRupee" },
  { title: "Long-Term Business Partnership", desc: "We grow when you grow — built for the long game.", icon: "Handshake" },
];

export const PROCESS = [
  { step: "01", title: "Free Consultation", desc: "A no-obligation strategy call to understand your business." },
  { step: "02", title: "Business Research", desc: "Deep dive into your market, competitors and customers." },
  { step: "03", title: "Marketing Strategy", desc: "Custom channel-mix, creative direction and offer design." },
  { step: "04", title: "Campaign Launch", desc: "Set up creatives, audiences, funnels and tracking." },
  { step: "05", title: "Optimization & Scaling", desc: "Continuous testing to lower CAC and scale ROAS." },
];

export const BUDGETS = [
  "₹5,000 – ₹10,000",
  "₹10,000 – ₹25,000",
  "₹25,000 – ₹50,000",
  "₹50,000 – ₹1,00,000",
  "Above ₹1,00,000",
];

export const SERVICE_OPTIONS = [
  "Meta Ads", "Facebook Ads", "Instagram Ads", "Lead Generation",
  "Landing Page", "Website", "AI Content", "AI Video Editing",
  "Graphic Design", "Social Media Marketing",
];

export const BUSINESS_CATEGORIES = [
  "Restaurant", "Salon / Spa", "Clinic / Doctor", "Gym / Fitness",
  "Hospital", "Education / Coaching", "Retail Shop", "Jewellery",
  "Real Estate", "Travel & Tourism", "Construction", "Manufacturing",
  "Automobile / Dealership", "Finance / Insurance", "E-commerce Brand",
  "Service Business", "Other",
];

export const STATS = [
  { label: "AI-Powered", value: 100, suffix: "%", sub: "Modern marketing workflows", icon: "Sparkles" },
  { label: "Support", value: 24, suffix: "×7", sub: "Real people on WhatsApp", icon: "Users" },
  { label: "Response Time", value: 1, suffix: " Day", sub: "Business-day reply guarantee", icon: "Rocket" },
  { label: "Focus", value: 100, suffix: "%", sub: "Indian businesses only", icon: "TrendingUp" },
];

export const TESTIMONIALS = [
  {
    quote:
      "The VR Marketing Hub team helped us set up Meta Ads from scratch. Enquiries on WhatsApp started coming in during the first week itself, and the reporting has been very clear.",
    name: "Rahul K.",
    role: "Founder · Restaurant, Jaipur",
    initials: "RK",
  },
  {
    quote:
      "What I liked most was the transparent communication and how they built a landing page that matched our jewellery brand. Cost per lead reduced significantly within a month.",
    name: "Priya S.",
    role: "Owner · Jewellery Boutique, Ahmedabad",
    initials: "PS",
  },
  {
    quote:
      "As a real estate developer, our sales cycle is long. They set up a proper lead nurturing flow on WhatsApp + CRM that keeps our leads engaged. Very professional team.",
    name: "Aman M.",
    role: "Director · Real Estate, Pune",
    initials: "AM",
  },
];

export const INDIAN_STATES = [
  "Andhra Pradesh","Arunachal Pradesh","Assam","Bihar","Chhattisgarh","Goa","Gujarat",
  "Haryana","Himachal Pradesh","Jharkhand","Karnataka","Kerala","Madhya Pradesh",
  "Maharashtra","Manipur","Meghalaya","Mizoram","Nagaland","Odisha","Punjab","Rajasthan",
  "Sikkim","Tamil Nadu","Telangana","Tripura","Uttar Pradesh","Uttarakhand","West Bengal",
  "Andaman and Nicobar Islands","Chandigarh","Dadra and Nagar Haveli and Daman and Diu",
  "Delhi","Jammu and Kashmir","Ladakh","Lakshadweep","Puducherry",
];

export const FAQS = [
  { q: "Do you work only with Indian businesses?", a: "Yes — VR Marketing Hub is built specifically for Indian businesses. Our pricing, ad platforms, WhatsApp workflows and creative style are designed for Indian buyers." },
  { q: "How soon will I start getting leads?", a: "Most campaigns start delivering leads within the first 7–14 days of launch. The first 30 days are dedicated to learning, optimisation and scaling." },
  { q: "What is the minimum marketing budget you recommend?", a: "We recommend starting from ₹10,000/month in ad spend for meaningful results, though we tailor budgets based on your city, category and goals." },
  { q: "Do you handle both ads and creatives?", a: "Yes. We handle the full stack — strategy, ad creatives, videos, landing pages, targeting, tracking and reporting." },
  { q: "Will I get regular reports?", a: "Absolutely. You'll get transparent weekly reports and a dedicated point of contact on WhatsApp for real-time updates." },
  { q: "Do I need a website to start advertising?", a: "Not always. For lead generation we can build a high-converting landing page in a few days. For full brand presence, we recommend a website too." },
  { q: "How is VR Marketing Hub different from freelancers?", a: "You get a team — strategist, ad manager, designer and support — with a defined process, AI tools and long-term accountability." },
];
